var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "duplicate-project-wizard",
      class: { "duplicate-project-wizard--compact": !_vm.showHeader }
    },
    [
      _c(
        "div",
        {
          ref: "wizardHeader",
          staticClass: "wizard-sticky-top",
          class: { "wizard-sticky-top--compact": !_vm.showHeader }
        },
        [
          _c(
            "div",
            {
              staticClass: "wizard-header",
              class: { "wizard-header--hidden": !_vm.showHeader }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "wizard-header-content" }, [
                _c("h4", [_vm._v("WIZARD")]),
                _vm._v(" "),
                _c("h2", [_vm._v("Duplicate Project Wizard")]),
                _vm._v(" "),
                _vm.sourceProject
                  ? _c("p", { staticClass: "mb-0" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.sourceProject.title) +
                          " (" +
                          _vm._s(_vm.sourceProject.project_number) +
                          ")\n        "
                      )
                    ])
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wizard-sticky-main" },
            [
              _c("WizardProgressBar", {
                attrs: {
                  steps: _vm.steps,
                  currentStep: _vm.currentStep,
                  "current-step-status":
                    _vm.currentStep === 3 ? _vm.duplicationStatus : "",
                  "max-clickable-step": _vm.stepNavigationDisabled
                    ? 0
                    : _vm.maxVisitedStep,
                  "navigation-disabled": _vm.stepNavigationDisabled
                },
                on: { "step-click": _vm.goToStep }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "wizard-action-bar" },
                [
                  _vm.duplicationInProgress
                    ? _c("b-spinner", {
                        attrs: { label: "Loading...", variant: "light" }
                      })
                    : _vm.duplicationStatus === "failed"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "wizard-action-status wizard-action-status--failed"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "wizard-action-status__indicator" },
                            [_c("i", { staticClass: "fas fa-times" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "wizard-action-status__label" },
                            [_vm._v("Error")]
                          )
                        ]
                      )
                    : _vm.duplicationStatus === "completed"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "wizard-action-status wizard-action-status--completed"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "wizard-action-status__indicator" },
                            [_c("i", { staticClass: "fas fa-check" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "wizard-action-status__label" },
                            [_vm._v("Finished")]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.stepNavigationDisabled
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary wizard-btn-cancel",
                          on: { click: _vm.cancel }
                        },
                        [_vm._v("Cancel")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.stepNavigationDisabled
                    ? _c("div", { staticClass: "wizard-action-bar__right" }, [
                        _vm.currentStep > 1
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary wizard-btn-prev",
                                on: { click: _vm.previousStep }
                              },
                              [_vm._v("Previous")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentStep < 3
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary wizard-btn-next",
                                attrs: { disabled: !_vm.canProceed },
                                on: { click: _vm.nextStep }
                              },
                              [_vm._v("Next")]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "wizard-header-spacer",
        style: { height: _vm.expandedWizardHeaderHeight + "px" }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wizard-body",
          style: { transform: _vm.wizardBodyTransform }
        },
        [
          _vm.loading
            ? _c(
                "div",
                { staticClass: "text-center p-5" },
                [
                  _c("b-spinner", { attrs: { label: "Loading..." } }),
                  _vm._v(" "),
                  _c("p", { staticClass: "mt-2" }, [
                    _vm._v("Loading project details...")
                  ])
                ],
                1
              )
            : _vm.error
            ? _c("div", { staticClass: "text-center p-5" }, [
                _c("p", { staticClass: "text-danger" }, [
                  _vm._v(_vm._s(_vm.error))
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function($event) {
                        return _vm.$router.go(-1)
                      }
                    }
                  },
                  [_vm._v("Go Back")]
                )
              ])
            : _c(
                "div",
                [
                  _vm.currentStep === 1
                    ? _c("DuplicateStep1ProjectDetails", {
                        ref: "step1",
                        attrs: { allProjects: _vm.allProjects }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep === 2
                    ? _c("DuplicateStep2SelectDeliverables", { ref: "step2" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep === 3
                    ? _c("DuplicateStep3Finish", {
                        ref: "step3",
                        on: {
                          "status-change": function($event) {
                            _vm.duplicationStatus = $event
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "duplication-icon" }, [
      _c("img", {
        attrs: { src: require("@/csmworkflow/img/duplication.svg") }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }